import React from 'react'
import { Document, Page, Text, Image, Font, StyleSheet, View } from '@react-pdf/renderer'
import { datiTabella  } from './tableGenerator';
import { returnSymbolString, NumberWithCommas } from '../Utils/utilFunctions';
import { E_GenereOmbrellone, E_TipoOmbrellone } from '../Utils/enumerations';

// Struttura del PDF generato al momento del salvataggio
export default function PDFStructure({title}) {
  let day = new Date();  
  day = day.getDate();
  let month = new Date(); 
  month = month.getMonth()+1;
  let year = new Date(); 
  year = year.getFullYear();  

  Font.register({
      family: 'Oswald',
      src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
    });

  const styles = StyleSheet.create({
    body: {
      paddingTop: 25,
      paddingBottom: 45,
      paddingHorizontal: 35,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      position: "relative",
    },
    header: {
      fontSize: 10,
      marginBottom: 10,
      textAlign: 'center',
      color: 'grey',
    },
    title: {
      fontSize: 16,
      textAlign: 'center',
      fontFamily: 'Oswald'
    },
    date: {
      fontSize: 8,
      textAlign: 'center',
      color: 'grey',
      marginBottom: 20,
    },
    subtitle: {
      fontSize: 18,
      margin: 12,
      fontFamily: 'Oswald'
    },
    category: {
      fontSize: 14,
      marginLeft: 5,
      marginTop: 2,   
      fontFamily: 'Oswald'
    },
    normalText: {
      margin: 3,
      fontSize: 9,
      textAlign: 'justify',
      fontFamily: 'Times-Roman'
    },
    prezziText: {
      margin: 1,
      fontSize: 9,
      textAlign: 'justify',
      fontFamily: 'Times-Roman',     
      marginLeft: 4,
    },
    noSpaceBetween: {
      margin: 1,
      marginLeft: 6,
      fontSize: 10,
      textAlign: 'justify',
      fontFamily: 'Times-Roman'
    },
    footer: {
      fontSize: 8,    
      textAlign: 'center',
      color: 'grey',
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
    row: {
      flex: 1,
      flexDirection: 'row',
      flexGrow: 1,
    },
    left: {
      width: '50%',//<- working alternative
      flexGrow: 0,
      flexShrink: 1,
      //flexBasis: 200,
    },  
    right: {
      paddingLeft: 5,
      width: '50%', //<- working alternative
      flexShrink: 1,
      flexGrow: 2,
    },
    totale: {
      fontSize: 16,
      textAlign: 'center',
      fontFamily: 'Oswald',
      marginTop: 8,
    },
    image: {
      marginVertical: 1,
      marginHorizontal: 1,
      height: "190px",
      width: "253px",
      zIndex: 1,
    }, 
    watermarkImage: {   
      marginTop: "50px",
      position: "absolute",  
      opacity: 0.1,
      width: "100vw",
      zIndex: 1000,
    }, 
    spacer: {
      margin: "10px"
    }    
  }); 

  return (
    <Document>        
      <Page style={styles.body} wrap size={"A4"}>   
        <Image
          style={styles.watermarkImage}
          src = {datiTabella.immagini.watermarkImage.src}
        /> 
        <Text style={styles.header} fixed>
          - Ombrellificio Il Parco -
        </Text>
        <Text style={styles.title}>{`${title} - Preventivo`}</Text>
        <Text style={styles.date}>{`${day}/${month}/${year}`}</Text>       
        <View style={styles.row}>
          <View style={styles.left}>
            <Text style={styles.category}>
              DIMENSIONI:
            </Text>
            <Text style={styles.normalText}>
              Lunghezza: {`${datiTabella.main.lunghezza} m`}
            </Text>  
            <Text style={styles.normalText}>
              Larghezza: {`${datiTabella.main.larghezza} m`}
            </Text>  
            <Text style={styles.normalText}>
              Ingresso: {datiTabella.main.ingresso}
            </Text>  
            <Text style={styles.normalText}>
              Colore strutture: {returnSymbolString(datiTabella.main.coloreStrutture)}
            </Text>       
            <Text style={styles.spacer}/>
              <Text style={styles.category}>
                  PEDANA:
              </Text>
            {datiTabella.pedana.isSelected && 
            <>             
              <Text style={styles.normalText}>
                Step altezza: {datiTabella.pedana.stepAltezza}
              </Text>  
              <Text style={styles.normalText}>
                Rivestimento: {datiTabella.pedana.rivestimento}
              </Text>  
              <Text style={styles.normalText}>
                Minigonna: {datiTabella.pedana.minigonna}
              </Text>        
              <Text style={styles.normalText}>
                Rampa disabili: {datiTabella.pedana.pedanaHasRampaDisabili}
              </Text>          
              <Text style={styles.normalText}>
                Numero botole: {datiTabella.pedana.pedanaNumBotole}
              </Text>
              <Text style={styles.prezziText}>
                Costo sottoscocca: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.sottoscocca)} €`}
              </Text>
              <Text style={styles.prezziText}>
                Costo rivestimento: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.rivestimento)} €`}
              </Text>
              <Text style={styles.prezziText}>
                Costo minigonna: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.minigonna)} €`}
              </Text>
              <Text style={styles.prezziText}>
                Costo rampa disabili: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.rampa)} €`}
              </Text>
              <Text style={styles.prezziText}>
                Costo botole: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.botole)} €`}
              </Text>
            </> 
            }
          </View>   
          <View style={styles.right}>  
            <Text style={styles.category}>
              PARAVENTI:
            </Text>  
            {datiTabella.paraventi.isSelected && 
            <>                   
              <Text style={styles.normalText}>
                Predisposizione Paraventi: {datiTabella.pedana.predParaventi}
              </Text>  
              <Text style={styles.normalText}>
                Tipo: {datiTabella.paraventi.tipo}
              </Text> 
              {datiTabella.paraventi.lati.map((element, index) => ( 
                <Text style={styles.noSpaceBetween} key={`paravento_lato_${index+1}`}>{`Lato ${index+1} = ${element === "SI" ? "SI" : "NO"}`}</Text>
              ))}     
              <Text style={styles.normalText}>
                Misura totale paraventi: {datiTabella.paraventi.perimetro}
              </Text>  
              <Text style={styles.normalText}>
                Porta: {datiTabella.paraventi.porta}
              </Text>
              <Text style={styles.prezziText}>
                Costo predisposizione paraventi: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.predParaventi)} €`}
              </Text>
              <Text style={styles.prezziText}>
                Costo paraventi: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.paraventi)} €`}
              </Text>
              <Text style={styles.prezziText}>
                Costo ingressi: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.porteParaventi)} €`}
              </Text>
            </>      
            }
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.left}>
            <Text style={styles.category}>
              OMBRELLONI:
            </Text>   
            {datiTabella.ombrelloni.isSelected &&
            <>             
              {(datiTabella.ombrelloni.tipo.toString() !== E_TipoOmbrellone.Scegli.toString() && datiTabella.ombrelloni.numero > 0) && 
              <>
                <Text style={styles.normalText}>
                  Genere: {datiTabella.ombrelloni.genere}
                </Text>  
                <Text style={styles.normalText}>
                  Tipo: {datiTabella.ombrelloni.tipo}
                </Text>           
                <Text style={styles.normalText}>
                  Misura: {returnSymbolString(datiTabella.ombrelloni.misura)}
                </Text>  
                <Text style={styles.normalText}>
                  Ombrelloni su misura: {datiTabella.ombrelloni.suMisura <= 0 ? "NO" : "SI"}
                </Text>  
                {datiTabella.ombrelloni.suMisura > 0 &&  
                <Text style={styles.normalText}>
                  Misura reale ombrelloni: {`${datiTabella.ombrelloni.suMisura} m`}
                </Text>}
                {datiTabella.ombrelloni.genere.toString() !== E_GenereOmbrellone.Centrale.toString() &&
                  <Text style={styles.normalText}>
                    Lato: {datiTabella.ombrelloni.lato}
                  </Text>
                }
                <Text style={styles.normalText}>
                  Numero totale ombrelloni: {datiTabella.ombrelloni.numero}
                </Text>            
                <Text style={styles.normalText}>
                  Colore tessuto: {returnSymbolString(datiTabella.ombrelloni.tessuto)}
                </Text>
                <Text style={styles.normalText}>
                  Nastratura cuciture: {datiTabella.ombrelloni.nastratura}
                </Text>
                <Text style={styles.normalText}>
                  Perimetro velcro: {datiTabella.ombrelloni.velcro}
                </Text>
                <Text style={styles.normalText}>
                  Attacchi esterni: {datiTabella.ombrelloni.attacchiEsterni}
                </Text>
                <Text style={styles.normalText}>
                  Grondaie: {datiTabella.ombrelloni.grondaie}
                </Text>
                <Text style={styles.normalText}>
                  Mantovana: {datiTabella.ombrelloni.mantovana}
                </Text>  
                <Text style={styles.normalText}>
                  Ombrelloni contrapposti: {datiTabella.ombrelloni.ombrelloniHasContrapposti}
                </Text>  
                <Text style={styles.normalText}>
                  Kit LED: {datiTabella.ombrelloni.hasLed}
                </Text>  
                <Text style={styles.normalText}>
                  Tipo Kit LED: {returnSymbolString(datiTabella.ombrelloni.tipoLed)}
                </Text>
                <Text style={styles.normalText}>
                  Dimmer + Telecomando: {datiTabella.ombrelloni.hasDimmerTel}
                </Text>
                <Text style={styles.prezziText}>
                  Costo predisposizione ombrelloni: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.predOmbrelloni)} €`}
                </Text>  
                {!datiTabella.ombrelloni.suMisura <= 0 && 
                <Text style={styles.prezziText}>
                  Costo ombrelloni: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.ombrelloni)} €`}
                </Text>}   
                {datiTabella.ombrelloni.suMisura > 0 && 
                <Text style={styles.prezziText}>
                  Costo ombrelloni su misura: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.ombrelloniSuMisura)} €`}
                </Text>}  
                <Text style={styles.prezziText}>
                  Costo nastratura e cuciture: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.nastratura)} €`}
                </Text> 
                <Text style={styles.prezziText}>
                  Costo grondaie: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.grondaie)} €`}
                </Text>
                <Text style={styles.prezziText}>
                  Costo velcro: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.velcro)} €`}
                </Text>
                <Text style={styles.prezziText}>
                  Costo LED: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.led)} €`}
                </Text>
              </>}
            </>
            }
          </View>         
          <View style={styles.right}>
            <Text style={styles.category}>
              LATERALE CRISTAL:
            </Text>  
            {datiTabella.cristal.isSelected &&
            <>               
              {datiTabella.cristal.lati.map((element, index) => ( 
                  <Text style={styles.noSpaceBetween} key={`cristal_lato_${index+1}`}>{`Lato ${index+1} = ${element === "SI" ? "SI" : "NO"}`}</Text>
              ))}  
              <Text style={styles.normalText}>
                Kit Porta Laterale Cristal: {datiTabella.cristal.kitPorta}
              </Text>
              <Text style={styles.normalText}>
                Numero sostegni Laterale Cristal: {datiTabella.cristal.numeroSostegni}
              </Text>  
              <Text style={styles.prezziText}>
                Costo laterale Cristal: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.cristal)} €`}
              </Text>    
              <Text style={styles.prezziText}>
                Costo kit porta Cristal: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.kitPortaCristal)} €`}
              </Text>      
              <Text style={styles.prezziText}>
                Costo sostegni laterale Cristal: {`${NumberWithCommas(datiTabella.calcolo.prezziParziali.sostegniCristal)} €`}
              </Text> 
            </>
            }   
          </View>
        </View>       
        <Text style={styles.footer}>
          - Il tessuto preventivato è ACRILICO RESINATO con CUCITURE NASTRATE.           
        </Text> 
        <Text style={styles.footer}>
          - Il PREZZO calcolato è da ritenersi indicativo e non vincolante.         
        </Text>       
        <Text style={styles.totale}> 
          TOTALE: {datiTabella.calcolo.totale}
        </Text>                
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />   
      </Page>
      <Page style={styles.body} wrap size={"A4"}>       
        <Image
          style={styles.watermarkImage}
          src = {datiTabella.immagini.watermarkImage.src}
        />      
        <Image
          style={styles.image}
          src = {datiTabella.immagini.arrayImmagini[0].src}
        />      
        <Image
          style={styles.image}
          src = {datiTabella.immagini.arrayImmagini[1].src}
        /> 
        <Image
          style={styles.image}
          src = {datiTabella.immagini.arrayImmagini[2].src}
        />
        <Image
          style={styles.image}
          src = {datiTabella.immagini.arrayImmagini[3].src}
        /> 
        <Text style={styles.header} fixed>
          - Ombrellificio Il Parco -
        </Text>
        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
          `${pageNumber} / ${totalPages}`
        )} fixed />          
      </Page>     
    </Document>    
  )
}
